
declare global {
  interface Window {
    gdprRedirects?: { [key: string]: string };
  }
}

interface GDPR {
  gdprPages: NodeListOf<HTMLElement> | null;
  init: (gdprElements: NodeListOf<HTMLElement>) => void;
}

const gdpr: GDPR = {
  gdprPages: null,

  init: function (gdprElements) {
    this.gdprPages = gdprElements;

    if (this.gdprPages.length < 1) {
      return;
    }

    console.log('gdpr.init()');

    // check for redirect, NHTCONT-680
    const hash = window.location.hash.replace('#', '');
    const redirects = window.gdprRedirects || {};

    if (hash && redirects[hash]) {
      console.log('redirecting to', redirects[hash]);
      window.location.href = redirects[hash];
    }
  },
};

export default gdpr;
